import { useParams } from 'react-router-dom';
import { useGraphQLClient } from '../../components/GraphQLClientProvider';
import { UnsubscribeController } from './UnsubscribeController';
import { createUnsubscribeFromNewsletterPromise } from '../../promises/createUnsubscribeFromNewsletterPromise';

export const Unsubscribe = () => {
  const { tag } = useParams();
  const client = useGraphQLClient();

  if (!tag) {
    throw new Error('Tag not found.');
  }

  return (
    <UnsubscribeController
      options={{
        context: {
          tag,
        },
        services: {
          unsubscribeFromNewsletter:
            createUnsubscribeFromNewsletterPromise(client),
        },
      }}
    />
  );
};
